<template>
    <div class="col-12">
        <div class="row">
            <b-overlay :show="loading" class="content">
                <div class="mb-3 text-center">
                    <hr />
                    <strong> محصولات فروشگاه {{ shopName }}</strong>
                    <hr />
                </div>
                <div class="w-100 mb-3 float-left">
                    <button type="button"
                            class="btn btn-light text-right"
                            @click="showFilters = true">
                        <font-awesome-icon class="mr-2 ml-2" icon="sliders-h" /> تنظیمات صفحه
                    </button>
                </div>
                <table v-if="screenWidth > 1021"
                       class="table table-bordered bg-white table-striped text-center">
                    <thead>
                        <tr>
                            <th v-for="field in fields" v-if="field.showCell" :key="field.key">
                                {{ $t("param.product." + field.key) }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items">
                            <td v-for="field in fields" v-if="field.showCell">
                                <span v-if="field.key == 'record'">
                                    {{ index + (currentPage - 1) * perPage + 1 }}
                                </span>
                                <span v-if="field.key == 'imagePath'">
                                    <img :src="item[field.key]" style="max-width:100px;" />
                                </span>
                                <span v-else-if="field.key == 'actions'">
                                    <button class="btn btn-dark btn-sm m-1"
                                            @click="onShowDatails(item)">
                                        مشاهده
                                    </button>
                                    <button class="btn btn-info btn-sm m-1"
                                            @click="onEdit(item)">
                                        ویرایش
                                    </button>
                                    <button class="btn btn-danger btn-sm m-1"
                                            @click="remove(item)">
                                        حذف
                                    </button>
                                </span>
                                <span v-else v-bind:class="{ 'card-number': field.cardNumber }">
                                    {{field.money ? new Intl.NumberFormat().format(item[field.key]) : item[field.key] }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table v-if="screenWidth < 1024"
                       v-for="(item, index) in items"
                       class="table table-light shadow-sm table-silver text-right" v-bind:class="{'table-silver': (index % 2 > 0)}">
                    <tr v-for="field in fields" v-if="field.showCellMobile">
                        <th>
                            {{ $t("param.product." + field.key) }}
                        </th>
                        <td>
                            <span v-if="field.key == 'record'">
                                {{ index + (currentPage - 1) * perPage + 1 }}
                            </span>
                            <span v-if="field.key == 'imagePath'">
                                <img :src="item[field.key]" style="max-width:100px;" />
                            </span>
                            <span v-if="field.key == 'actions'">
                                <button class="btn btn-dark btn-sm2 m-1"
                                        @click="onShowDatails(item)">
                                    مشاهده
                                </button>
                                <button class="btn btn-info btn-sm m-1"
                                        @click="onEdit(item)">
                                    ویرایش
                                </button>
                                <button class="btn btn-danger btn-sm m-1"
                                        @click="remove(item)">
                                    حذف
                                </button>
                            </span>
                            <span v-else v-bind:class="{ 'card-number': field.cardNumber }">
                                {{field.money ? new Intl.NumberFormat().format(item[field.key]) : item[field.key] }}
                            </span>
                        </td>
                    </tr>
                </table>

                <b-pagination dir="ltr"
                              pills
                              @input="initTable"
                              v-model="currentPage"
                              :total-rows="totalFilteredRows"
                              :per-page="perPage"
                              size="sm"></b-pagination>
            </b-overlay>
        </div>
        <b-modal size="lg" hide-footer v-model="showDetails">
            <div class="text-center">
                <strong class="d-block mb-3">
                    مشخصات محصول
                </strong>
                <table class="table text-center table-sm table-light">
                    <tr v-for="field in fields" v-if="field.shotDetails">
                        <th>{{ $t("param.product." + field.key) }}</th>

                        <td v-if="field.key == 'imagePath'">
                            <img :src="selected[field.key]" style="max-width:100px;" />
                        </td>
                        <td v-else>
                            {{field.money ? new Intl.NumberFormat().format(selected[field.key]) : selected[field.key] }}
                        </td>
                    </tr>
                </table>
            </div>
        </b-modal>
        <b-modal size="lg" hide-footer v-model="showFilters">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-md-7 float-right">
                        <table class="table table-borderless text-right">
                            <tr>
                                <td>{{ $t("param.table.perPage") }}</td>
                                <td>
                                    <b-form-select :options="perPageOptions"
                                                   class="form-control"
                                                   v-model="perPageSelectedOption"></b-form-select>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("param.table.fromDate") }}</td>
                                <td>
                                    <date-picker color="#f5c842"
                                                 v-model="fromDate"
                                                 :clearable="true" />
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("param.table.toDate") }}</td>
                                <td>
                                    <date-picker color="#f5c842"
                                                 v-model="toDate"
                                                 :clearable="true" />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-12 col-md-5 float-right">
                        <table class="table text-right table-light">
                            <tr v-for="(field, index) in fields" v-if="field.shotDetails">
                                <th>{{ $t("param.product." + field.key) }}</th>
                                <td>
                                    <b-form-checkbox switch
                                                     v-model="fields[index].showCell"
                                                     size="lg"></b-form-checkbox>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <button class="btn btn-outline-dark" @click="initFilters">
                        اعمال تنظیمات
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import store from "@/store";

    export default {
        props: {
            shopId: 0
        },
        data()
        {
            return {
                screenWidth: null,
                loading: false,
                showFilters: false,
                showSplits: false,
                showDetails: false,
                shopName: '',
                selected: {},
                items: [],
                fields: [
                    {
                        key: "record",
                        showCell: true,
                        shotDetails: false
                    },
                    {
                        key: "productId",
                        showCell: false,
                        shotDetails: false
                    },
                    {
                        key: "imagePath",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "name",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "productStatusName",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true,
                    },
                    {
                        key: "productLevel",
                        showCell: false,
                        shotDetails: false
                    },
                    {
                        key: "price",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true,
                        money: true
                    },
                    {
                        key: "count",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true,
                        money: true
                    },
                    {
                        key: "wagePercent",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: true
                    },
                    {
                        key: "description",
                        showCell: false,
                        showCellMobile: false,
                        shotDetails: true
                    },
                    {
                        key: "actions",
                        showCell: true,
                        showCellMobile: true,
                        shotDetails: false
                    }
                ],
                fromDate: null,
                toDate: null,
                totalRows: 1,
                totalFilteredRows: 1,
                currentPage: 1,
                perPage: 10,
                perPageSelectedOption: "10",
                perPageOptions: [
                    { text: 10, value: 10 },
                    { text: 50, value: 50 },
                    { text: 100, value: 100 },
                    { text: 500, value: 500 }
                ]
            };
        },

        beforeMount()
        {
            store.selectedShop = null;
            store.selectedProduct = null;

            this.screenWidth = window.outerWidth;
            this.initTable();
        },

        mounted()
        {
            this.totalRows = this.items.length;
        },

        methods: {
            initFilters()
            {
                this.showFilters = false;
                this.perPage = Number(this.perPageSelectedOption);
                this.initTable();
            },

            initTable()
            {
                this.loading = true;

                const data = {
                    Search: "",
                    Start: (this.currentPage - 1) * this.perPage,
                    Length: this.perPage,
                    FromDate: this.fromDate,
                    ToDate: this.toDate,
                    ShopID: this.shopId
                };

                axios({ method: "post", url: "/api/app/GetShopProducts", data: data })
                    .then(response =>
                    {
                        this.items = response.data.meta.products;
                        this.totalRows = response.data.meta.totalRows;
                        this.totalFilteredRows = response.data.meta.totalFilteredRows;
                        this.shopName = response.data.meta.shopName;
                        this.loading = false;
                    })
                    .catch(error => { });
            },

            remove(item)
            {
                var self = this;
                var data = {
                    ProductID: item.productId,
                    ShopID: item.shopId,
                }

                if (confirm("آیا از حذف اطمینان دارید؟"))
                {

                    self.loading = true;

                    axios({ method: "post", url: "/api/app/RemoveProduct", data: data })
                        .then(response =>
                        {
                            self.loading = false;

                            if (response.data.success)
                            {
                                self.$bvToast.toast('محصول شما با موفقیت حذف شد', {
                                    title: 'عملیات موفق',
                                    toaster: 'b-toaster-top-center',
                                    variant: 'success',
                                    bodyClass: 'text-center',
                                    noCloseButton: true,
                                    solid: true
                                })

                                self.initTable();

                                return;
                            }

                            self.$bvToast.toast('خطا در حذف محصول، لطفا با پشتیانی سیستم تماس بگیرید.', {
                                title: 'عملیات ناموفق',
                                toaster: 'b-toaster-top-center',
                                variant: 'danger',
                                bodyClass: 'text-center',
                                noCloseButton: true,
                                solid: true
                            })
                        })
                        .catch(error => { });
                }
            },


            onEdit(item)
            {
                store.selectedProduct = item;
                store.selectedProduct.shopName = this.shopName;
                this.$router.push({ name: 'club', params: { action: 'shopCreateProduct' } });
            },

            onShowDatails(item)
            {
                this.selected = item;
                this.showDetails = true;
            }
        }
    };
</script>
<style>
    .card-number {
        display: inline-block;
        direction: ltr;
    }
</style>
